import { Component, OnDestroy, OnInit, SkipSelf } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FireflyMobileModalComponent, ModalContent } from '../../../modal';
import { FireflyBaseSuggesterComponent } from '../base-suggester/base-suggester.component';

@Component({
  selector: 'f-mobile-suggester',
  template: ''
})
export class FireflySuggesterMobileComponent implements OnInit, OnDestroy, ModalContent {
  context!: FireflyBaseSuggesterComponent;
  modalInstance!: NgbActiveModal;
  referenceSibling!: HTMLElement;
  isFirstChild = false;
  clone!: HTMLElement;

  constructor(@SkipSelf() private modalContainer: FireflyMobileModalComponent) {}

  ngOnInit() {
    this.clone = this.context.baseHost.nativeElement.cloneNode(true);
    this.context.baseHost.nativeElement.classList.add('modal-suggester');
    this.referenceSibling = this.context.baseHost.nativeElement.nextSibling;
    this.isFirstChild = this.context.container.firstChild === this.context.baseHost.nativeElement;
    this.modalContainer.modalBody.nativeElement.prepend(this.context.baseHost.nativeElement);

    window.requestAnimationFrame(() => this.context.inputElement.nativeElement.focus());

    if (this.isFirstChild) {
      this.context.container.prepend(this.clone);
    } else if (this.referenceSibling) {
      this.context.container.insertBefore(this.clone, this.referenceSibling);
    } else {
      this.context.container.append(this.clone);
    }
  }

  ngOnDestroy() {
    this.context.baseHost.nativeElement.classList.remove('modal-suggester');
    this.context.container.insertBefore(this.context.baseHost.nativeElement, this.clone);
    this.context.toggleDropdown(false);
    this.clone.remove();
  }
}
